import axios from 'axios';
import { getAuthHeader } from './api-utils';

const api_base_url = 'https://api.profitkit.io';
const baseURL =
  process.env.NODE_ENV === 'production'
    ? api_base_url
    : process.env.VUE_APP_API_BASE_URL ?? api_base_url;

const API = axios.create({
  withCredentials: true,
  baseURL, // 'http://localhost:5000', //
});

/* Send auth header if it exists in session */
API.interceptors.request.use(
  config => {
    const authHeader = getAuthHeader();

    if (authHeader) {
      config.headers['Authorization'] = authHeader;
    }

    return config;
  },

  error => {
    console.error(error);
    return Promise.reject(error);
  },
);

export default API;
